import Filters from "./Filters";
import FormatPicker from "./FormatPicker";
import MonthAndDatePicker from "./MonthAndDatePicker";

const Header = () => {
  return (
    <div className="tw-bg-tr-black tw-sticky tw-top-0 tw-z-20 ">
      <div className="custom-container-tr tw-grid tw-grid-cols-1 md:tw-grid-cols-[25%_50%_25%]">
        <div className="tw-flex tw-items-center tw-justify-between">
          <FormatPicker />
          <div className="tw-block md:tw-hidden">
            <Filters />
          </div>
        </div>
        <MonthAndDatePicker />
        <div className="tw-hidden md:tw-flex tw-items-center tw-justify-self-end">
          <Filters />
        </div>
      </div>
    </div>
  );
};

export default Header;
